import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Redirect } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Script from 'react-load-script'
import { graphql } from 'react-apollo'
// import gql from 'graphql-tag'
import { Button, Row, Col, message, Spin, Modal, Icon } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
import _entries from 'lodash/entries'
// import config from '~/config'
// import queryString from 'query-string'
import moment from 'moment'

import OrderSteps from '~/App/components/OrderSteps'
import OmiseModal from '~/App/components/OmiseModal'
import TransferModal from '~/App/components/TransferModal'
import orderQuery from '~/App/graphql/queries/order.gql'
import payOrderMutation from '~/App/graphql/mutations/payOrder.gql'
import localeGet from '~/App/utils/localeGet'
// import './styles.css'

const getFee = ({ amount, rate }) => {
  // return Math.ceil(amount / (1 - fee)) - amount
  return Math.round(rate * amount * 100) / 100
}

@injectIntl
@inject('i18n')
@observer
@graphql(orderQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id }
  })
})
@graphql(payOrderMutation, {
  name: 'payOrder'
})
class OrderPayment extends Component {
  state = {
    // showGatewaysModal: false,
    omiseLoaded: false,
    showOmiseModal: false,
    showOmiseNetbankModal: false,
    showBankTransferModal: false,
    paymentLoading: false
  }

  // linePayUrl = ({ urlType }) => (
  //   `${config('baseUri')}/payment`
  // )
  handleOmiseLoaded = () => {
    this.setState({
      omiseLoaded: true
    })
  }

  // calculateAmount = registration => {
  //   let amount = 0
  //   registration.participants.forEach(participant => {
  //     participant.tickets.forEach(ticket => {
  //       discounted += ticket.ticketType.price
  //     })
  //   })
  //   return amount
  // }

  handleLinepaycheckout = async e => {
    e.preventDefault()
    this.setState({
      paymentLoading: true
    })
    const { order } = this.props.data
    // this.props.form.validateFields((err, omiseData) => {
    //   if (!err) {
    try {
      const { data } = await this.props.payOrder({
        variables: {
          record: {
            masterId: order._id,
            masterType: 'Order',
            registrationId: order.registrationId,
            eventId: order.eventId,
            method: 'linepay',
            data: {
              linepay: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/orders/${order._id}`
                // confirmUrl: `${config('baseUri')}/linepayconfirm`,
                // cancelUrl: `${config('baseUri')}/linepaycancel`
              }
            }
          }
        }
      })
      const paymentUrl = _get(
        data,
        'payOrder.record.data.linepay.paymentUrl.web'
      )
      if (paymentUrl) {
        window.location.href = paymentUrl
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
      this.setState({ paymentLoading: false })
    }
  }

  handleOmiseCheckout = async ({ token, card }) => {
    this.setState({
      paymentLoading: true
    })
    const { order } = this.props.data
    try {
      const { data } = await this.props.payOrder({
        variables: {
          record: {
            masterId: order._id,
            masterType: 'Order',
            registrationId: order.registrationId,
            eventId: order.eventId,
            method: 'omise_card',
            data: {
              omise: {
                ...(token && {
                  bin: token.bin,
                  token: {
                    id: token.id,
                    save_card: token.saveCard
                  }
                }),
                ...(card && {
                  card: {
                    id: card.id
                  }
                })
              }
            }
          }
        }
      })
      const { masterId, data: { omise: { error } } } = _get(data, 'payOrder.record')
      let title = ''
      let content = ''
      if (error) {
        switch (error) {
          case 'the security code is invalid':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.invalidSecurityCode' })
            break
          case 'insufficient funds in the account or the card has reached the credit limit':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.insufficientFunds' })
            break
          case 'payment rejected':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.paymentRejected' })
            break
          case 'card is stolen or lost':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.stolenOrLostCard' })
            break
          case 'failed processing':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.failedProcessing' })
            break
          case 'failed fraud check':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.failedFraudCheck' })
            break
          case 'the account number is invalid':
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = this.props.intl.formatMessage({ id: 'charge.failureCode.invalidAccountNumber' })
            break
          default:
            title = this.props.intl.formatMessage({ id: 'charge.failureCode.title' })
            content = error
        }
        Modal.error({
          title: title,
          content: content
        })
      } else {
        if (masterId) {
          this.props.history.push(`/orders/${masterId}`)
        }
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          Modal.error({
            title: this.props.intl.formatMessage({ id: 'charge.failureCode.title' }),
            content: this.props.intl.formatMessage({ id: `api.${error.message}` })
          })
        })
      } else {
        Modal.error({
          title: this.props.intl.formatMessage({ id: 'charge.failureCode.title' }),
          content: err.message
        })
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
  }

  handleTransferCheckout = async checkoutData => {
    const { order } = this.props.data
    this.setState({
      paymentLoading: true
    })
    try {
      const { data } = await this.props.payOrder({
        variables: {
          record: {
            masterId: order._id,
            masterType: 'Order',
            registrationId: order.registrationId,
            eventId: order.eventId,
            method: 'transfer',
            data: {
              transfer: checkoutData
            }
          }
        }
      })
      const { masterId } = _get(data, 'payOrder.record')
      if (masterId) {
        this.props.history.push(`/orders/${masterId}`)
      }
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
  }

  handleOmiseOffsiteCheckout = async ({ method, type, amount }) => {
    this.setState({
      paymentLoading: true
    })
    // Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY) // eslint-disable-line no-undef
    // console.log(omiseData, config('omisePublicKey'))
    const { order } = this.props.data
    const { intl, i18n: { locale } } = this.props
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(process.env.REACT_APP_OMISE_PUBLIC_KEY)
    const paymentMethod = _get(order, 'event.settings.payment.methods', []).find(i => i.method === 'omise_card')
    const publicKey = _get(paymentMethod, 'publicKey')
    if (publicKey) {
      // eslint-disable-next-line no-undef
      Omise.setPublicKey(publicKey)
    }
    try {
      const source = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createSource(type, { currency: 'thb', amount: Math.round(amount * 100) }, (statusCode, response) => {
          if (statusCode !== 200) {
            return reject(response.message)
          }
          return resolve(response)
        })
      })
      const { data } = await this.props.payOrder({
        variables: {
          record: {
            masterId: order._id,
            masterType: 'Order',
            registrationId: order.registrationId,
            eventId: order.eventId,
            method,
            data: {
              omise: {
                source: { id: source.id },
                returnUri: `${process.env
                  .REACT_APP_BASE_URI}/orders/${order._id}`
              }
            }
          }
        }
      })
      const references = _get(
        data,
        'payOrder.record.data.omise.charge.source.references'
      )
      const authorizeUri = _get(
        data,
        'payOrder.record.data.omise.charge.authorize_uri'
      )
      const showTescoBarcode = ({$slip}) => {
        const w = window.open()
        ReactDOM.render($slip, w.document.body)
        w.addEventListener('load', function () {
          // window.alert('loaded')
          // w.alert('loaded 2')
        }, true)
        // w.setTimeout(() => {
        //   w.focus()
        //   w.print()
        //   w.close()
        // }, 1000)
      }
      const eventName = _get(order, 'event.name')[locale]
      if (references) {
        const expiresAt = moment(references.expires_at)
          .format('lll')
        const $slip = <div className="tescoSlipWrapper">
          <div className="tescoSlip">
            <div><img id="tescoBarcode" src={references.barcode} style={{ width: '100%' }} alt='Barcode' /></div>
            <h3>{eventName}</h3>
            <div>ชำระที่ {intl.formatMessage({ id: `paymentMethod.omise_tesco` })}</div>
            <div>
              {intl.formatMessage(
                { id: `app.payBaht` },
                { amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).total) }
              )}
            </div>
            <div>oid: {order._id}</div>
            <div>ref1: {references.reference_number_1}</div>
            <div>ref2: {references.reference_number_2}</div>
            <div>{intl.formatMessage({ id: `paymentMethod.expiry` })}: {expiresAt}</div>
          </div>
        </div>
        Modal.confirm({
          style: { top: 0 },
          className: 'tescoModal',
          content: $slip,
          okText: [<Icon type="printer" />, intl.formatMessage({ id: `app.print` })],
          onOk () {
            showTescoBarcode({$slip})
          }
        })
      }
      if (authorizeUri) window.location.href = authorizeUri
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      this.setState({ paymentLoading: false })
    }
  }

  handlePayatallCheckout = async checkoutData => {
    const { order } = this.props.data
    this.setState({
      paymentLoading: true
    })
    return this.props
      .payOrder({
        variables: {
          record: {
            masterId: order._id,
            masterType: 'Order',
            registrationId: order.registrationId,
            eventId: order.eventId,
            method: 'payatall_cash',
            data: {
              payatall: {
                completeRedirect: `${process.env
                  .REACT_APP_BASE_URI}/orders/${order._id}`
              }
            }
          }
        }
      })
      .then(({ data }) => {
        // const { _id } = _get(data, 'payOrder.record')
        const formData = _get(data, 'payOrder.record.data.payatall.formData')
        const form = document.createElement('form')
        form.setAttribute('method', 'post')
        form.setAttribute('action', formData.payNowUrl)
        // form.setAttribute('target', 'PayAtAll')
        _entries(formData).forEach(([key, value]) => {
          const input = document.createElement('input')
          input.type = 'hidden'
          input.name = key
          input.value = value
          form.appendChild(input)
        })
        document.body.appendChild(form)
        form.submit()
      }).catch(err => {
        const { graphQLErrors } = err
        if (graphQLErrors) {
          graphQLErrors.forEach(error => {
            message.error(this.props.intl.formatMessage({ id: `api.${error.message}` }))
          })
        } else {
          message.error(err.message)
        }
        this.setState({ paymentLoading: false })
      })
  }

  handleOmiseModalClose = e => {
    this.setState({
      showOmiseModal: false
    })
  }

  handleOmiseModalClose = e => {
    this.setState({
      showOmiseModal: false
    })
  }

  handleBankTransferModalOpen = e => {
    this.setState({
      showBankTransferModal: true
    })
  }

  handleBankTransferModalClose = e => {
    this.setState({
      showBankTransferModal: false
    })
  }
  gatewayRate = gateway => {
    const { registration } = this.props.data
    const gatewayFees = _get(
      registration,
      'event.settings.payment.gatewayFees',
      []
    )
    const gwf = gatewayFees.find(gwf => gwf.gateway === gateway)
    return gwf ? gwf.fee : 0
  }

  getAmount = ({ gateway }) => {
    const { order } = this.props.data
    const discounted = _get(order, 'amount.discounted')
    const fee = getFee({ amount: discounted, rate: this.gatewayRate(gateway) })
    return {
      total: discounted + fee,
      discounted,
      fee
    }
  }

  render () {
    const { data, i18n: { locale }, intl } = this.props
    const { order, loading } = data
    const omiseMethod = _get(order, 'event.settings.payment.methods', []).find(i => i.method === 'omise_card')
    const omisePublicKey = _get(omiseMethod, 'publicKey', process.env.REACT_APP_OMISE_PUBLIC_KEY) || process.env.REACT_APP_OMISE_PUBLIC_KEY
    // console.log({ order })
    // const { search } = this.props.location
    // const { l: locale = 'th' } = queryString.parse(search)

    if (loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    } else if (!order) {
      return <div>Order Not found</div>
    }
    // const { paymentQuotaExceeded } = order

    const { status, amount } = order
    const { discounted } = amount
    const gatewayFees = _get(
      order,
      'event.settings.payment.gatewayFees',
      []
    )
    const customMessage = _get(
      order,
      'event.settings.payment.customMessage'
    )

    // const systemFee = _get(order, 'event.settings.registration.fee', 0)

    const enabledMethods = _get(order, 'event.settings.payment.methods', [])
      .filter(method => method.enabled).reduce((methods, item) => {
        methods[item.method] = true
        return methods
      }, {})

    const gatewayRate = gateway => {
      const gwf = gatewayFees.find(gwf => gwf.gateway === gateway)
      return gwf ? gwf.fee : 0
    }

    // const linepayFee = gatewayRate('linepay')
    // const omiseFee = gatewayRate('omise')
    // const transferFee = gatewayRate('transfer')

    // const amount = registration ? this.calculateAmount(registration) : 0

    const paymentButtonStyle = {
      display: 'block',
      margin: '8px auto'
    }
    const paymentGroupStyle = {
      border: '1px dashed gainsboro',
      padding: '8px',
      marginBottom: '16px'
    }

    const bankAccountInfo = _get(
      order,
      'event.settings.payment.bankAccountInfo'
    )

    const getAmount = ({ gateway }) => {
      const fee = getFee({ amount: discounted, rate: gatewayRate(gateway) })
      return {
        total: discounted + fee,
        discounted,
        fee
      }
    }

    return status && status === 'paid'
      ? <Redirect to={`/orders/${order._id}`} />
      : <div className="EventRegisterPage">
        <div className="innerEventRegisterPage">
          <div className="dividedBox">
            <div className="registrationTopTitle">
              {localeGet(data, 'order.event.name', locale)}
            </div>
            <OrderSteps step="pay"/>
          </div>
          <div className="dividedBox">
            <div>
              <Script
                url="https://cdn.omise.co/omise.js.gz"
                onLoad={this.handleOmiseLoaded}
                onError={() => console.error('error loading omise')}
              />
              <h1><FormattedMessage id="app.selectPaymentMethod" defaultMessage="Select payment method"/></h1>
              <div style={{paddingBottom: '8px'}}><FormattedMessage id="app.orderCode" /> : {order.code}</div>
              {customMessage &&
                <blockquote style={{ textAlign: 'center' }}>
                  {localeGet(customMessage, '', locale)}
                </blockquote>
              }
              {this.state.omiseLoaded &&
                <Row type="flex" justify="center" gutter={16} style={{ textAlign: 'center' }}>
                  {enabledMethods['omise_card'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.omise_card"/></div>
                      <div>
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(getAmount({ gateway: 'omise' }).fee)
                        }}/>
                      </div>
                      <Button
                        icon="credit-card"
                        type="primary"
                        onClick={() => this.setState({ showOmiseModal: true })}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(getAmount({ gateway: 'omise' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['linepay'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.linepay"/></div>
                      <div>
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(getAmount({ gateway: 'linepay' }).fee)
                        }}/>
                      </div>
                      <Button
                        type="primary"
                        onClick={this.handleLinepaycheckout}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(getAmount({ gateway: 'linepay' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['transfer'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.transfer"/></div>
                      <div>
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(getAmount({ gateway: 'transfer' }).fee)
                        }}/>
                      </div>
                      <Button
                        type="primary"
                        onClick={this.handleBankTransferModalOpen}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(getAmount({ gateway: 'transfer' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['omise_alipay'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.omise_alipay"/></div>
                      <div>
                        <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted)
                        }} />
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).fee)
                        }}/>
                      </div>
                      <Button
                        icon="alipay"
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            method: 'omise_alipay',
                            type: 'alipay',
                            amount: this.getAmount({ gateway: 'omise' }).total }
                          )}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="app.payBaht" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).total)
                        }}/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['omise_tesco'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.omise_tesco"/></div>
                      <div>
                        <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).discounted)
                        }} />
                        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
                          amount: intl.formatNumber(this.getAmount({ gateway: 'omise' }).fee)
                        }}/>
                      </div>
                      <Button
                        icon="barcode"
                        type="primary"
                        onClick={e =>
                          this.handleOmiseOffsiteCheckout({
                            method: 'omise_tesco',
                            type: 'bill_payment_tesco_lotus',
                            amount: this.getAmount({ gateway: 'omise' }).total }
                          )}
                        style={paymentButtonStyle}
                      >
                        <FormattedMessage id="paymentMethod.showBarcode"/>
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['omise_netbank'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div style={{ fontWeight: 'bold' }}><FormattedMessage id="paymentMethod.omise_netbank"/></div>
                      <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" tagName="div" values={{
                        amount: intl.formatNumber(getAmount({ gateway: 'omise' }).fee)
                      }}/>
                      <FormattedMessage id="app.bankProcessingFeeBaht" defaultMessage="Bank Processing Fee" tagName="div" values={{
                        amount: intl.formatNumber(10)
                      }}/>
                      <FormattedMessage id="app.payBaht" tagName="div" values={{
                        amount: intl.formatNumber(getAmount({ gateway: 'omise' }).total + 10)
                      }}/>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseNetbankCheckout({
                            type: 'internet_banking_bay',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        KrugsriOnline
                      </Button>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseNetbankCheckout({
                            type: 'internet_banking_bbl',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        Bualuang iBanking
                      </Button>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseNetbankCheckout({
                            type: 'internet_banking_ktb',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        KTB Netbank
                      </Button>
                      <Button
                        type="primary"
                        onClick={e =>
                          this.handleOmiseNetbankCheckout({
                            type: 'internet_banking_scb',
                            method: 'omise_netbank',
                            amount: this.getAmount({ gateway: 'omise' }).total
                          })}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        SCBEasy
                      </Button>
                    </div>
                  </Col>}
                  {enabledMethods['payatall_cash'] && <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
                    <div style={paymentGroupStyle}>
                      <div>Counter Service</div>
                      <FormattedMessage id="app.payBaht" tagName="div" values={{
                        amount: intl.formatNumber(getAmount({ gateway: 'payatall_cash' }).total)
                      }}/>
                      <Button
                        onClick={e => this.handlePayatallCheckout()}
                        loading={this.state.paymentLoading}
                        style={paymentButtonStyle}
                      >
                        Counter Service (
                        {discounted})
                      </Button>
                    </div>
                  </Col>}
                </Row>}
              <OmiseModal
                amount={
                  getAmount({ gateway: 'omise' }).total
                }
                visible={this.state.showOmiseModal}
                loading={this.state.paymentLoading}
                onCheckout={this.handleOmiseCheckout}
                onClose={this.handleOmiseModalClose}
                locale={locale}
                publicKey={omisePublicKey}
              />
              <TransferModal
                bankAccountInfo={bankAccountInfo}
                amount={
                  getAmount({ gateway: 'transfer' }).total
                }
                visible={this.state.showBankTransferModal}
                loading={this.state.paymentLoading}
                onCheckout={this.handleTransferCheckout}
                onClose={this.handleBankTransferModalClose}
                locale={locale}
              />
            </div>
          </div>
        </div>
      </div>
  }
}

export default OrderPayment

// TODO: transfor props get rid of data



// WEBPACK FOOTER //
// ./src/App/pages/OrderPayment/OrderPayment.js